import {Injectable} from '@angular/core';
import {WindowReferenceService} from './window-reference.service';
import {Documentation} from '../documentation/documentation.model';
import {SessionStorage} from "ngx-webstorage";
import {Item, Project} from "../../project/shared/project-model";
import {User} from "../user/user";

@Injectable({
  providedIn: 'root'
})

export class FileDownloadEventDatalayerService {
  private window;

  @SessionStorage() currentProject: Project;
  @SessionStorage() currentItemct: Item;
  @SessionStorage() user: User;

  constructor(private windowRef: WindowReferenceService) {
    this.window = windowRef.nativeWindow;
  }

  private DataLayerTrigger(fileDownloadEvent) {
    if (fileDownloadEvent) {
      this.window.dataLayer.push(fileDownloadEvent);
    }
  }

  FileDownloadEvent(fileInfo: Documentation) {
    let document_id = fileInfo.id;
    let document_name = (fileInfo.fileName == fileInfo.id) ? fileInfo.title : fileInfo.fileName;
    let document_type = fileInfo.extension;

    let event = {
      event: 'file_download',
      configurator_id: 46676,
      configurator_name: 'EcoStruxure PowerBuild Contractors',
      document_id: document_id,
      document_name: document_name,
      document_type: document_type,
      configuration_id: this.currentItemct?.id,
      configuration_name: this.currentItemct?.name,
      project_id: this.currentProject?.id,
      project_name: this.currentProject?.name,
      user_id: this.user.id
    }
    this.DataLayerTrigger(event);
  }

  FileDownloadParameterEvent(documentId: string, documentName: string, documentType: string) {
    let event = {
      event: 'file_download',
      configurator_id: 46676,
      configurator_name: 'EcoStruxure PowerBuild Contractors',
      document_id: documentId,
      document_name: documentName,
      document_type: documentType,
      configuration_id: this.currentItemct?.id,
      configuration_name: this.currentItemct?.name,
      project_id: this.currentProject?.id,
      project_name: this.currentProject?.name,
      user_id: this.user.id
    }
    this.DataLayerTrigger(event);
  }
}
